import { createSelector } from 'reselect';
import { getFabricDataValues } from './config';


export const getFabricSearchQuery = state => state.ui.fabricSearchQuery;

const keyFields = ['displayName', 'shortName'];

const concatKeyFields = (e, fields) => {
    return Object.keys(e).reduce((prev, cur) => (
        fields.indexOf(cur) > -1 ?
            prev += e[cur] : prev
    ), '').toLowerCase()//.replace(/\s/g, '')
}

export const makeGetFilter = (query) => (
    function (e) {
        const fields = concatKeyFields(e, keyFields);
        return fields.indexOf(query.trim().toLowerCase()) > -1
    }
)

export const getFabricMatch = createSelector(
    getFabricDataValues,
    getFabricSearchQuery,
    (fabricData, queryParams) => {
        const filter = makeGetFilter(queryParams);
        return fabricData.filter(filter);
    }
)
